export interface StatusColorConfig {
  background: string;
  color: string;
}

export const DEFAULT_STATUS_COLORS: Record<string, StatusColorConfig> = {
  pending: { background: '#8F8EA3', color: '#F5F5F7' },
  approved: { background: '#62CB99', color: '#F5F5F7' },
  confirmed: { background: '#62CB99', color: '#F5F5F7' },
  completed: { background: '#62CB99', color: '#F5F5F7' },
  rejected: { background: '#E9554A', color: '#F5F5F7' },
  cancelled: { background: '#E9554A', color: '#F5F5F7' },

  active: { background: '#62CB99', color: '#F5F5F7' },
  inactive: { background: '#8F8EA3', color: '#F5F5F7' },
  draft: { background: '#FFB147', color: '#F5F5F7' },
  in_progress: { background: '#5B93FF', color: '#F5F5F7' },

  low: { background: '#62CB99', color: '#F5F5F7' },
  medium: { background: '#FFB147', color: '#F5F5F7' },
  high: { background: '#E9554A', color: '#F5F5F7' },

  available: { background: '#62CB99', color: '#F5F5F7' },
  partially_available: { background: '#F59E0B', color: '#F5F5F7' },
  booked: { background: '#FDE5E3', color: '#E9554A' },
  not_available: { background: '#E9554A', color: '#F5F5F7' },

  default: { background: '#8F8EA3', color: '#F5F5F7' },
};

export const BOOLEAN_STATUS_COLORS: Record<string, StatusColorConfig> = {
  yes: { background: '#62CB99', color: '#F5F5F7' },
  no: { background: '#E9554A', color: '#F5F5F7' },
};
